import { createActions } from 'redux-actions';

export const nameActions = createActions(
  {
    GET: (payload) => payload,
    SET: (payload) => payload,
    CREATE: (payload) => payload,
    UPDATE: (payload) => payload,
    ADD_NOTE: (action) => action,
  },
  {
    prefix: 'Profile/BIOGRAPHICAL/NAME',
  }
);

export default nameActions;
